import axios from "axios";

export const state = {
    schoolstreams: [],
};

export const getters = {
    schoolstreams: state => state.schoolstreams,
};

export const mutations = {
    setStream(state, newValue) {
        state.schoolstreams = newValue
    },
};

export const actions = {
    fetchSchoolStreams({ commit }) {
        axios.get('/schoolstreams').then(res => {
            commit('setStream', res.data.schoolstreams);
        })
    },
};
